module.exports = __webpack_public_path__ + "img/bigwavetop.9db5ea9e.png";